(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('BinSearch', BinSearch);

    BinSearch.$inject = ['$resource'];

    function BinSearch($resource) {
        var resourceUrl =  'api/_search/bins/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
